import { render, staticRenderFns } from "./payDialog.vue?vue&type=template&id=0a8f24c4&scoped=true"
import script from "./payDialog.vue?vue&type=script&lang=js"
export * from "./payDialog.vue?vue&type=script&lang=js"
import style0 from "./payDialog.vue?vue&type=style&index=0&id=0a8f24c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8f24c4",
  null
  
)

export default component.exports